module.exports = __webpack_public_path__ + "img/sme.69ff78fd.svg";